// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportManagerConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
//

import localizer from 'share/localization/Izenda.Localizer';

export default {
  get TABLE_DEF() {
    return {
        name: {
          key: 'name',
          columnKey: 'reportName',
          width: 200,
          title: localizer.getText('EXPORT_MANAGER_TABEL_DEF_COLUMN_TITLE_NAME')
        },
        fileType: {
          key: 'exportFileType',
          columnKey: 'fileType',
          width: 200,
          title: localizer.getText('EXPORT_MANAGER_TABEL_DEF_COLUMN_TITLE_FILE_TYPE')
        },
        exportedDate: {
          key: 'created',
          columnKey: 'exportedDate',
          width: 100,
          title: localizer.getText('EXPORT_MANAGER_TABEL_DEF_COLUMN_TITLE_EXPORTED_DATE')
        },
        refreshedDate: {
          key: 'refreshed',
          columnKey: 'refreshedDate',
          width: 100,
          title: localizer.getText('EXPORT_MANAGER_TABEL_DEF_COLUMN_TITLE_REFRESHED_DATE')
        },
        status: {
          key: 'status',
          columnKey: 'status',
          width: 100,
          title: localizer.getText('EXPORT_MANAGER_TABEL_DEF_COLUMN_TITLE_STATUS')
        },
        downloadFile: {
          key: 'fileName',
          columnKey: 'downloadFile',
          width: 50,
          title: localizer.getText('EXPORT_MANAGER_TABEL_DEF_COLUMN_TITLE_DOWNLOAD_FILE'),
          align: 'center'
        },
        delete: {
          key: 'delete',
          columnKey: 'delete',
          width: 50,
          title: localizer.getText('EXPORT_MANAGER_TABEL_DEF_COLUMN_TITLE_DELETE'),
          align: 'center'
        }
    };
  },
  get STATUS(){
    return {
      PENDING: {
        title: localizer.getText('EXPORT_MANAGER_STATUS_PENDING'),
        class: 'exporting-status-pending'
      },
      COMPLETED: {
        title: localizer.getText('EXPORT_MANAGER_STATUS_COMPLETED'),
        class: 'exporting-status-completed'
      },
      FAILED: {
        title: localizer.getText('EXPORT_MANAGER_STATUS_FAILED'),
        class: 'exporting-status-failed'
      }
    }
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ExportManagerConstants.js